import { hasString } from '../../string';
import { IdsOption } from '../option.types';
import { ListboxFilterType } from './listbox.types';

export const filterListboxOptions = (
  options: IdsOption[] = [],
  value = '',
  {
    filter = 'none',
  }: {
    filter?: ListboxFilterType;
  } = {},
) =>
  options.filter((option) => {
    const text = String(option.label);
    const search = String(value);

    switch (filter) {
      case 'startsWith':
        return hasString(text, search, {
          method: 'startsWith',
        });
      case 'includes':
        return hasString(text, search);
      case 'none':
        return true;

      default:
        if (typeof filter === 'function') {
          return filter(text, search);
        } else {
          return true;
        }
    }
  });
